import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AgentComponent } from './agent.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';

@NgModule({
  providers:[LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/agent-area', component:AgentComponent, canActivate:[LanguageInterceptor]},
    ])
  ]
})
export class AgentRoutingModule { 

    
}
